import { appConfig } from "@/commons";
import type { SignupPayload, SignupSuccess, ApiError } from "@/types/auth";

export async function signupUser(
  payload: SignupPayload,
): Promise<SignupSuccess> {
  const res = await fetch(`${appConfig.api.baseUrl}/users/signup`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    // keep/remove credentials depending on whether your API sets cookies
    // credentials: "include",
    body: JSON.stringify(payload),
    credentials: "include",
  });

  const text = await res.text();
  const data = text ? (JSON.parse(text) as unknown) : {};
  if (!res.ok) {
    const err = data as ApiError;
    const msg = Array.isArray(err?.message)
      ? err.message.join(", ")
      : err?.message;
    throw new Error(msg || `Signup failed (${res.status})`);
  }
  return data as SignupSuccess;
}
